import { TaskDetail } from './TaskDetail'

interface TaskDetailPanelProps {
  taskId: number
  onClose: () => void
}

export function TaskDetailPanel({ taskId, onClose }: TaskDetailPanelProps) {
  return (
    <div className="hidden lg:block w-[400px] flex-shrink-0 rounded-xl border border-base overflow-hidden h-full overflow-y-auto bg-surface-primary shadow-lg">
      <TaskDetail taskId={taskId} onBack={onClose} panelMode />
    </div>
  )
}
